import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const sanitizeCognitoUsername = value => {
    if (!value) {
        return '';
    }

    // test US phone number
    const usPhoneNumber = parsePhoneNumberFromString(value, 'US');
    if (usPhoneNumber?.isPossible()) {
        return usPhoneNumber.number;
    }

    // test other phone numbers
    const valueToTest = value[0] === '+' ? value : `+${value}`;
    const phoneNumber = parsePhoneNumberFromString(valueToTest);
    if (phoneNumber?.isPossible()) {
        return phoneNumber.number;
    }

    return value.trim();
};

export const getDecodedQuery = encodedQuery => {
    if (!encodedQuery) {
        return {};
    }

    try {
        const decodedQuery = atob(encodedQuery);

        // new URLSearchParams(decodedQuery) loses `+` sign in user email, so reduce is a workaround
        return decodedQuery.split('&').reduce((acc, item) => {
            const [key, value] = item.split('=');
            return {
                ...acc,
                [key]: value,
            };
        }, {});
    } catch (e) {
        console.error(e);
        return {};
    }
};
